  <template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='12'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Créer une nouvelle actualité</strong>
          </div>
          <b-row>
            <b-form-group label='Date de début'
                          label-for='date_debut'
                          class="col-lg-4 col-md-6 col-sm-12">
              <b-form-input id='date_debut'
                            type='date'
                            :class="{hasError: errors.date_debut !== ''}"
                            v-model="date_debut">
              </b-form-input>
              <span class='field-error'>{{ errors.date_debut }}</span>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group label='Date de fin'
                          label-for='date_fin'
                          class="col-lg-4 col-md-6 col-sm-12">
              <b-form-input id='date_fin'
                            type='date'
                            v-model="date_fin">
              </b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group label="Nature"
                          label-for="nature"
                          :horizontal="true"
                          class="col-lg-4 col-md-6 col-sm-12">
              <b-form-select id="nature"
                             :class="{hasError: errors.nature !== ''}"
                             :plain="true"
                             :options="natureOptions"
                             v-model="nature">
              </b-form-select>
              <span class='field-error'>{{ errors.nature }}</span>
            </b-form-group>
          </b-row>
          <b-form-group label='Titre'
                        label-for='titre'>
            <b-form-input id='titre'
                          type='text'
                          :class="{hasError: errors.titre !== ''}"
                          v-model="titre">
            </b-form-input>
            <span class='field-error'>{{ errors.titre }}</span>
          </b-form-group>
          <b-form-group label='Resumé' v-if="nature !== 'Météo'">
            <ckeditor :editor="editor" v-model="resume" :config="editorConfig"></ckeditor>
          </b-form-group>
          <b-form-group label='Texte' v-if="nature !== 'Météo'">
            <ckeditor :editor="editor" v-model="texte" :config="editorConfig"></ckeditor>
          </b-form-group>
          <b-row>
            <b-form-group label="Pièce jointe"
                          label-for='nom_fichier'
                          class="col-lg-4 col-md-6 col-sm-12">
              <b-form-file :placeholder="pieceJointePlaceholder"
                           class="file-input"
                           drop-placeholder="Déposer le fichier ici..."
                           browse-text="Parcourir"
                           :state="errors.attachment !== '' ? false : null"
                           @change="addFile($event)">
              </b-form-file>
              <span class="field-error">{{ errors.attachment }}</span>
            </b-form-group>
          </b-row>
          <span class="mt-3 mb-3">Destinataires</span>
          <b-row>
            <b-col lg="4" md="6" sm="12" v-if="profilesReady" v-for="(element, key) in profilesOptions" :key="key">
              <b-card class="mt-3" no-body>
                <div class="card-smallHeader card-header-action" v-b-toggle="'collapse' + key">
                    <b-form-checkbox v-model="allSelected[element.code]"
                                     :indeterminate="indeterminate[element.code]"
                                     aria-describedby="items"
                                     aria-controls="items"
                                     @change="toggleAll($event, element.code)"
                                     class="header-checkbox">
                      {{ element.code }}
                    </b-form-checkbox>
                  <div class="card-header-actions">
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                        <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  </div>
                </div>
                <b-collapse :id="'collapse' + key">
                  <b-card-body class="small-padding">
                    <b-form-checkbox v-for="profile in element.profiles"
                                     v-model="selectedRows[profile.codeLibelle]"
                                     :value="profile.id"
                                     :key="profile.id"
                                     class="col-lg-12">
                      {{ profile.libelle }}
                    </b-form-checkbox>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des actualités
            </b-button>
            <b-button type="button" @click="add('publié')" size="md" class="pull-right" variant="primary">
              Diffuser
            </b-button>
            <b-button type="button" @click="add('brouillon')" size="md" class="pull-right mr-2" variant="warning">
              Brouillon
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr';
  import {isEmpty, permittedExtension} from "@/utils/fileHelper";
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  const groupOrder = [
          'Pôle Flux Entrant',
          'Service Prestations',
          'Service Entreprise',
          'Pôle Qualité',
          'Relation client',
          'Direction Gestion Prévoyance',
          'Equipes Commerciales',
          'Extérieur Chorum',
          'Autres',
        ];

  const profilNotConcerned = ['0T','00','ZZ'];

  export default {
    name: "Add",
    data() {
      return {
        date_debut: '',
        date_fin: '',
        titre: '',
        resume: '',
        texte: '',
        nature: '',
        natureOptions: [
          'Evolution Produit/CCN',
          'Evolution de services au client',
          'Information client',
          'Information interne',
          'Consigne métier',
          'Météo',
          'Autres',
        ],
        selectedProfiles: [],
        profiles: [],
        editor: ClassicEditor,
        editorConfig: {
          allowedContent: true,
          toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'],
          language: 'fr'
        },
        errors: {
          date_debut: '',
          date_fin: '',
          titre: '',
          resume: '',
          texte: '',
          nature: '',
          attachment: '',
          destinataires: '',
        },
        profilesReady: false,
        attachment: null,
        pieceJointePlaceholder: null,
        profilesOptions: [],
        selectedRows: {
          'Service Entreprise': [],
          'Service Prestations': [],
          'Equipes Commerciales': [],
          'Direction Gestion Prévoyance': [],
          'Extérieur Chorum': [],
          'Pôle Qualité': [],
          'Relation client': [],
          'Pôle flux entrant': [],
          'Autres': [],
        },
        allSelected: {
          'Service Entreprise': false,
          'Service Prestations': false,
          'Equipes Commerciales': false,
          'Direction Gestion Prévoyance': false,
          'Extérieur Chorum': false,
          'Pôle Qualité': false,
          'Relation client': false,
          'Pôle flux entrant': false,
          'Autres': false,
        },
        indeterminate: {
          'Service Entreprise': false,
          'Service Prestations': false,
          'Equipes Commerciales': false,
          'Direction Gestion Prévoyance': false,
          'Extérieur Chorum': false,
          'Pôle Qualité': false,
          'Relation client': false,
          'Pôle flux entrant': false,
          'Autres': false,
        },
        codeLibelleArray: [
          'Service Entreprise',
          'Service Prestations',
          'Equipes Commerciales',
          'Direction Gestion Prévoyance',
          'Extérieur Chorum',
          'Pôle Qualité',
          'Relation client',
          'Pôle flux entrant',
          'Autres'
        ],
      }
    },
    mounted() {
      this.getProfiles();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    watch: {
      selectedRows: {
        deep: true,

        handler() {
          this.handleCheckboxGroup();
        }
      },
    },
    methods: {
      getProfiles() {
        let self = this;
        this.$axios
          .get("/administration/profiles")
          .then((response) => {
            const profiles = response.data.profils;
            if (profiles.length > 0) {
              this.profilesReady = true;
              this.setProfiles(profiles);
            }
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      add(etat) {
        this.selectedProfiles = Object.values(this.selectedRows).flat();
        if (this.validateForm()) {
          let self = this;
          let formData = new FormData();
          formData.append('file', this.attachment);
          formData.append('date_debut', this.date_debut);
          formData.append('date_fin', this.date_fin);
          formData.append('titre', this.titre);
          formData.append('resume', this.resume);
          formData.append('texte', this.texte);
          formData.append('nature', this.nature);
          formData.append('etat', etat);
          formData.append('destinataires', this.selectedProfiles);
          this.$axios
            .post('/espaceGestion/actualites/store', formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Une nouvelle actualité a bien été créé',
                showConfirmButton: false,
                timer: 2500
              });
              setTimeout(() => {
                this.$router.push({path: '/espace-gestion/actualite/list'})
              }, 2800);
            })
            .catch(() => {
              this.handleErrors(self);
            });
        }
        else {
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Vous devez saisir les champs obligatoires',
            showConfirmButton: false,
            timer: 3500
          });
        }
      },
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/actualite"});
      },
      validateForm() {
        this.clearErrors();
        let isValid = true;
        if (isEmpty(this.date_debut)) {
          isValid = false;
          this.errors.date_debut = 'Veuillez choisir une date de début';
        }
        if (isEmpty(this.titre)) {
          isValid = false;
          this.errors.titre = 'Veuillez choisir un titre';
        }
        if (isEmpty(this.nature)) {
          isValid = false;
          this.errors.nature = 'Veuillez choisir une nature';
        }
        if (this.selectedProfiles.length === 0) {
          isValid = false;
          this.errors.destinataires = 'Veuillez choisir un destinataire au moins';
        }
        if (!isEmpty(this.attachment)) {
          if (!_.includes(permittedExtension, this.attachment.name.split('.').pop())) {
            isValid = false;
            this.errors.attachment = "Le Format de fichier n'est pas autorisé";
          }
        }
        return isValid;
      },
      clearErrors() {
        this.errors.date_debut = '';
        this.errors.date_fin = '';
        this.errors.titre = '';
        this.errors.resume = '';
        this.errors.texte = '';
        this.errors.attachment = '';
      },
      handleErrors(self) {
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: "Une erreur est survenue lors de l'ajout de l'actualité. Si le problème persiste, merci de faire un ticket au support DOSI.",
          showConfirmButton: false,
          timer: 4000
        });
      },
      setProfiles(data) {
        this.profilesOptions = _(data)
          .filter(element => {
            if (profilNotConcerned.indexOf(element.code) === -1) {
              // console.log(element)
              element.codeLibelle = this.getCodeLibelleFromCodeSubstring(element.code);
              return element;
            }
            return false;
          })
          .groupBy('codeLibelle')
          .map((value, key) => {
            return ({code: key, profiles: value, count: value.length});
          })
          .sortBy((val) => {
            return groupOrder.indexOf(val.code);
          })
          .value();
          console.log(this.profilesOptions)
      },
      toggleAll(checked, code) {
        let filteredData = this.profilesOptions.filter(item => code === item.code);
        let profiles = filteredData.length > 0 ? filteredData[0].profiles : [];
        this.selectedRows[code] = checked ? profiles.map(item => {
          return code === item.codeLibelle ? item.id : null;
        }) : [];
      },
      getCodeLibelleFromCodeSubstring(code) {
        if(code.includes('Presta_')) {
          return 'Service Prestations';
        }
        if(code.includes('ENT_')) {
          return 'Service Entreprise';
        }
        if(code.includes('DEV_')) {
          return 'Equipes Commerciales';
        }
        if(code.includes('Admin_')) {
          return 'Direction Gestion Prévoyance';
        }
        if(code.includes('DGP_')) {
          return 'Direction Gestion Prévoyance';
        }
        if(code.includes('EXT_')) {
          return 'Extérieur Chorum';
        }
        if(code.includes('Qual_')) {
          return 'Pôle Qualité';
        }
        if(code.includes('RC_')) {
          return 'Relation client';
        }
        if(code.includes('QC_')) {
          return 'Pôle flux entrant';
        }
        else {
          return 'Autres';
        }
      },
      handleCheckboxGroup() {
        for (let code of this.codeLibelleArray) {
          let filteredData = this.profilesOptions.filter(item => code === item.code);
          console.log(filteredData)
          let count = filteredData.length > 0 ? filteredData[0].count : 0;
          this.manageCheckboxGroup(code, count);
        }
      },
      manageCheckboxGroup(codeLibelle, count) {
        if (this.selectedRows[codeLibelle].length === 0) {
          this.allSelected[codeLibelle] = false
          this.indeterminate[codeLibelle] = false
        } else if (this.selectedRows[codeLibelle].length === count) {
          this.allSelected[codeLibelle] = true
          this.indeterminate[codeLibelle] = false
        } else {
          this.allSelected[codeLibelle] = false
          this.indeterminate[codeLibelle] = true
        }
        console.log(codeLibelle, count,this.selectedRows[codeLibelle],this.indeterminate[codeLibelle])
      }
    }
  }
</script>
